import React from 'react';

import Layout from 'client/app/apps/disco-prototype/MakeMixturePage/Layout';
import Page from 'client/app/apps/disco-prototype/MakeMixturePage/Page';

export default () => (
  <Layout>
    <Page />
  </Layout>
);
